export default __webpack_public_path__ + "static/media/sponsor_toyota.108c7e7c.svg";